export type PricingAssetLocale = 'ko' | 'en' | 'ja';

export const getPricingAssetLocale = (
  locale: string | undefined,
): PricingAssetLocale => {
  if (locale === 'ko' || locale === 'ja') return locale;

  return 'en';
};

export const getPricingDataDashboardImageSrc = (locale: string | undefined) => {
  const assetLocale = getPricingAssetLocale(locale);

  return assetLocale === 'ko'
    ? 'datadashboard.png'
    : `datadashboard_${assetLocale}.png`;
};
